import { render, staticRenderFns } from "./DepartmentCard.vue?vue&type=template&id=ea871d7e"
import script from "./DepartmentCard.vue?vue&type=script&lang=js"
export * from "./DepartmentCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports